import React from 'react';
import { Header, Hero, Section, Testimonials, Footer } from './components/layouts';

function App() {
  return (
    <div className="min-h-screen bg-background-default">
      <Header />
      <Hero />
      <Section />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
